export default __webpack_public_path__ + "static/media/timezone.66e34fc4.svg";